import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import { Home, Contact, Confirmation, Candidat, Recettes, Error404 } from "@/Pages/Public/Index";

import Layout from "@/Layouts/Layout";

const PublicRouter = () => {
    return (
        <Routes>
            <Route element={<Layout />}>
                <Route path="" element={<Navigate to="/home" />} />
                <Route path="/home" element={<Home />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/candidat" element={<Candidat />} />
                <Route path="/recettes" element={<Recettes />} />
                <Route path="/confirmation" element={<Confirmation />} />
                <Route path="*" element={<Error404 />} />
            </Route>
        </Routes>
    );
};

export default PublicRouter;